/**
 * 
 */
var jmeMenus = [
{menu: 'fence',x: 0,y: 0,width: 54,height: 24,
items: [{name:'fence_parenthesis',x: 54,y: 0,width: 24,height: 24},
{name:'fence_curlybrace',x: 78,y: 0,width: 24,height: 24},
{name:'fence_anglebrace',x: 102,y: 0,width: 24,height: 24},
{name:'fence_bracket',x: 126,y: 0,width: 24,height: 24},
{name:'fence_single_bar',x: 150,y: 0,width: 24,height: 24},
{name:'fence_double_bar',x: 174,y: 0,width: 24,height: 24},
{name:'fence_bracket_top',x: 198,y: 0,width: 24,height: 24},
{name:'fence_bracket_bottom',x: 222,y: 0,width: 24,height: 24},
{name:'fence_double_bracket',x: 246,y: 0,width: 24,height: 24},
{name:'fence_bracket_parenthesis',x: 270,y: 0,width: 24,height: 24},
{name:'fence_parenthesis_bracket',x: 294,y: 0,width: 24,height: 24},
{name:'fence_bar_angle_brace',x: 318,y: 0,width: 24,height: 24},
{name:'fence_angle_brace_bar',x: 342,y: 0,width: 24,height: 24},
{name:'fence_left_bracket_bracket',x: 366,y: 0,width: 24,height: 24},
{name:'fence_right_bracket_bracket',x: 390,y: 0,width: 24,height: 24},
{name:'fence_bracket_bracket_reverse',x: 414,y: 0,width: 24,height: 24},
{name:'fence_left_parenthesis',x: 438,y: 0,width: 24,height: 24},
{name:'fence_left_curly_brace',x: 462,y: 0,width: 24,height: 24},
{name:'fence_left_angle_brace',x: 486,y: 0,width: 24,height: 24},
{name:'fence_left_bracket',x: 510,y: 0,width: 24,height: 24},
{name:'fence_left_single_bar',x: 534,y: 0,width: 24,height: 24},
{name:'fence_left_double_bar',x: 558,y: 0,width: 24,height: 24},
{name:'fence_left_double_bracket',x: 582,y: 0,width: 24,height: 24},
{name:'fence_right_parenthesis',x: 606,y: 0,width: 24,height: 24},
{name:'fence_right_curly_brace',x: 630,y: 0,width: 24,height: 24},
{name:'fence_right_angle_brace',x: 654,y: 0,width: 24,height: 24},
{name:'fence_right_bracket',x: 678,y: 0,width: 24,height: 24},
{name:'fence_right_single_bar',x: 702,y: 0,width: 24,height: 24},
{name:'fence_right_double_bar',x: 726,y: 0,width: 24,height: 24},
{name:'fence_right_double_bracket',x: 750,y: 0,width: 24,height: 24},
{name:'fence_middle_bar',x: 774,y: 0,width: 24,height: 24},
{name:'fence_middle_double_bar',x: 0,y: 24,width: 24,height: 24},
{name:'fence_angle_bar_angle',x: 24,y: 24,width: 24,height: 24},
]},
{menu: 'fraction',x: 48,y: 24,width: 54,height: 24,
items: [{name:'fraction',x: 102,y: 24,width: 24,height: 24},
{name:'division',x: 126,y: 24,width: 24,height: 24},
{name:'division_no_bar',x: 150,y: 24,width: 24,height: 24},
{name:'slash_fraction',x: 174,y: 24,width: 24,height: 24},
{name:'small_division',x: 198,y: 24,width: 24,height: 24},
{name:'small_fraction',x: 222,y: 24,width: 24,height: 24},
{name:'root',x: 246,y: 24,width: 24,height: 24},
{name:'root_with_indice',x: 270,y: 24,width: 24,height: 24},
{name:'long_division',x: 294,y: 24,width: 24,height: 24},
]},
{menu: 'subsup',x: 318,y: 24,width: 54,height: 24,
items: [{name:'ss_subscript',x: 372,y: 24,width: 24,height: 24},
{name:'ss_superscript',x: 396,y: 24,width: 24,height: 24},
{name:'ss_sub_superscript',x: 420,y: 24,width: 24,height: 24},
{name:'ss_subscript_only',x: 444,y: 24,width: 24,height: 24},
{name:'ss_superscript_only',x: 468,y: 24,width: 24,height: 24},
{name:'ss_sub_superscript_only',x: 492,y: 24,width: 24,height: 24},
{name:'ss_left_subscript_only',x: 516,y: 24,width: 24,height: 24},
{name:'ss_left_superscript_only',x: 540,y: 24,width: 24,height: 24},
{name:'ss_left_sub_superscript_only',x: 564,y: 24,width: 24,height: 24},
{name:'ss_subscript_large',x: 588,y: 24,width: 24,height: 24},
{name:'ss_superscript_large',x: 612,y: 24,width: 24,height: 24},
{name:'ss_sub_superscript_large',x: 636,y: 24,width: 24,height: 24},
{name:'ou_over_script',x: 660,y: 24,width: 24,height: 24},
{name:'ou_under_script',x: 684,y: 24,width: 24,height: 24},
{name:'ou_over_under_script',x: 708,y: 24,width: 24,height: 24},
{name:'ou_over_script_large',x: 732,y: 24,width: 24,height: 24},
{name:'ou_under_script_large',x: 756,y: 24,width: 24,height: 24},
{name:'ou_over_under_script_large',x: 0,y: 48,width: 24,height: 24},
]},
{menu: 'embellish',x: 24,y: 48,width: 54,height: 24,
items: [{name:'em_top_bar',x: 78,y: 48,width: 24,height: 24},
{name:'em_top_double_bar',x: 102,y: 48,width: 24,height: 24},
{name:'em_bottom_bar',x: 126,y: 48,width: 24,height: 24},
{name:'em_bottom_double_bar',x: 150,y: 48,width: 24,height: 24},
{name:'em_top_curly',x: 174,y: 48,width: 24,height: 24},
{name:'em_middle_curly_up',x: 198,y: 48,width: 24,height: 24},
{name:'em_middle_curly_dn',x: 222,y: 48,width: 24,height: 24},
{name:'em_bottom_curly',x: 246,y: 48,width: 24,height: 24},
{name:'em_top_prnt',x: 270,y: 48,width: 24,height: 24},
{name:'em_middle_prnt_up',x: 294,y: 48,width: 24,height: 24},
{name:'em_middle_prnt_dn',x: 318,y: 48,width: 24,height: 24},
{name:'em_bottom_prnt',x: 342,y: 48,width: 24,height: 24},
{name:'em_top_bracket',x: 366,y: 48,width: 24,height: 24},
{name:'em_middle_bracket_up',x: 390,y: 48,width: 24,height: 24},
{name:'em_middle_bracket_dn',x: 414,y: 48,width: 24,height: 24},
{name:'em_bottom_bracket',x: 438,y: 48,width: 24,height: 24},
{name:'em_top_tilde',x: 462,y: 48,width: 24,height: 24},
{name:'em_top_constant_ramp',x: 486,y: 48,width: 24,height: 24},
{name:'em_top_ramp',x: 510,y: 48,width: 24,height: 24},
{name:'em_top_triangle',x: 534,y: 48,width: 24,height: 24},
{name:'em_cross',x: 558,y: 48,width: 24,height: 24},
{name:'em_cross_horizontal',x: 582,y: 48,width: 24,height: 24},
{name:'em_cross_horizontal_double',x: 606,y: 48,width: 24,height: 24},
{name:'em_cross_vertical',x: 630,y: 48,width: 24,height: 24},
{name:'em_cross_vertical_double',x: 654,y: 48,width: 24,height: 24},
{name:'em_cross_slash',x: 678,y: 48,width: 24,height: 24},
{name:'em_cross_back_slash',x: 702,y: 48,width: 24,height: 24},
]},
{menu: 'shortarrow',x: 726,y: 48,width: 54,height: 24,
items: [{name:'em_top_short_left_arrow',x: 0,y: 72,width: 24,height: 24},
{name:'em_top_short_right_arrow',x: 24,y: 72,width: 24,height: 24},
{name:'em_top_short_left_right_arrow',x: 48,y: 72,width: 24,height: 24},
{name:'em_top_short_left_single_arrow',x: 72,y: 72,width: 24,height: 24},
{name:'em_top_short_right_single_arrow',x: 96,y: 72,width: 24,height: 24},
{name:'em_bottom_short_left_arrow',x: 120,y: 72,width: 24,height: 24},
{name:'em_bottom_short_right_arrow',x: 144,y: 72,width: 24,height: 24},
{name:'em_bottom_short_left_right_arrow',x: 168,y: 72,width: 24,height: 24},
{name:'em_bottom_short_left_single_arrow',x: 192,y: 72,width: 24,height: 24},
{name:'em_bottom_short_right_single_arrow',x: 216,y: 72,width: 24,height: 24},
]},
{menu: 'long_arrow',x: 240,y: 72,width: 54,height: 24,
items: [{name:'em_top_long_left_arrow',x: 294,y: 72,width: 24,height: 24},
{name:'em_top_long_right_arrow',x: 318,y: 72,width: 24,height: 24},
{name:'em_top_long_left_right_arrow',x: 342,y: 72,width: 24,height: 24},
{name:'em_top_long_long_arrow',x: 366,y: 72,width: 24,height: 24},
{name:'em_top_long_short_arrow',x: 390,y: 72,width: 24,height: 24},
{name:'em_top_long_long_single_arrow',x: 414,y: 72,width: 24,height: 24},
{name:'em_top_long_short_single_arrow',x: 438,y: 72,width: 24,height: 24},
{name:'em_top_long_left_duo_arrow',x: 462,y: 72,width: 24,height: 24},
{name:'em_top_long_right_duo_arrow',x: 486,y: 72,width: 24,height: 24},
{name:'em_top_long_left_right_duo_arrow',x: 510,y: 72,width: 24,height: 24},
{name:'em_bottom_long_left_arrow',x: 534,y: 72,width: 24,height: 24},
{name:'em_bottom_long_right_arrow',x: 558,y: 72,width: 24,height: 24},
{name:'em_bottom_long_left_right_arrow',x: 582,y: 72,width: 24,height: 24},
{name:'em_bottom_long_long_arrow',x: 606,y: 72,width: 24,height: 24},
{name:'em_bottom_long_short_arrow',x: 630,y: 72,width: 24,height: 24},
{name:'em_bottom_long_long_single_arrow',x: 654,y: 72,width: 24,height: 24},
{name:'em_bottom_long_short_single_arrow',x: 678,y: 72,width: 24,height: 24},
{name:'em_bottom_long_left_duo_arrow',x: 702,y: 72,width: 24,height: 24},
{name:'em_bottom_long_right_duo_arrow',x: 726,y: 72,width: 24,height: 24},
{name:'em_bottom_long_left_right_duo_arrow',x: 750,y: 72,width: 24,height: 24},
{name:'em_middle_long_left_arrow',x: 774,y: 72,width: 24,height: 24},
{name:'em_middle_long_right_arrow',x: 0,y: 96,width: 24,height: 24},
{name:'em_middle_long_left_right_arrow',x: 24,y: 96,width: 24,height: 24},
{name:'em_middle_long_long_arrow',x: 48,y: 96,width: 24,height: 24},
{name:'em_middle_long_short_arrow',x: 72,y: 96,width: 24,height: 24},
{name:'em_middle_long_long_single_arrow',x: 96,y: 96,width: 24,height: 24},
{name:'em_middle_long_short_single_arrow',x: 120,y: 96,width: 24,height: 24},
{name:'em_middle_long_left_duo_arrow',x: 144,y: 96,width: 24,height: 24},
{name:'em_middle_long_right_duo_arrow',x: 168,y: 96,width: 24,height: 24},
{name:'em_middle_long_left_right_duo_arrow',x: 192,y: 96,width: 24,height: 24},
]},
{menu: 'largeop',x: 216,y: 96,width: 54,height: 24,
items: [{name:'sum_with_none',x: 270,y: 96,width: 24,height: 24},
{name:'sum_with_sub',x: 294,y: 96,width: 24,height: 24},
{name:'sum_with_super',x: 318,y: 96,width: 24,height: 24},
{name:'sum_with_sub_sup',x: 342,y: 96,width: 24,height: 24},
{name:'sum_with_over',x: 366,y: 96,width: 24,height: 24},
{name:'sum_with_under',x: 390,y: 96,width: 24,height: 24},
{name:'sum_with_over_under',x: 414,y: 96,width: 24,height: 24},
{name:'product_with_none',x: 438,y: 96,width: 24,height: 24},
{name:'product_with_sub',x: 462,y: 96,width: 24,height: 24},
{name:'product_with_super',x: 486,y: 96,width: 24,height: 24},
{name:'product_with_sub_sup',x: 510,y: 96,width: 24,height: 24},
{name:'product_with_over',x: 534,y: 96,width: 24,height: 24},
{name:'product_with_under',x: 558,y: 96,width: 24,height: 24},
{name:'product_with_over_under',x: 582,y: 96,width: 24,height: 24},
{name:'coproduct_with_none',x: 606,y: 96,width: 24,height: 24},
{name:'coproduct_with_sub',x: 630,y: 96,width: 24,height: 24},
{name:'coproduct_with_super',x: 654,y: 96,width: 24,height: 24},
{name:'coproduct_with_sub_sup',x: 678,y: 96,width: 24,height: 24},
{name:'coproduct_with_over',x: 702,y: 96,width: 24,height: 24},
{name:'coproduct_with_under',x: 726,y: 96,width: 24,height: 24},
{name:'coproduct_with_over_under',x: 750,y: 96,width: 24,height: 24},
{name:'union_with_none',x: 774,y: 96,width: 24,height: 24},
{name:'union_with_sub',x: 0,y: 120,width: 24,height: 24},
{name:'union_with_super',x: 24,y: 120,width: 24,height: 24},
{name:'union_with_sub_sup',x: 48,y: 120,width: 24,height: 24},
{name:'union_with_over',x: 72,y: 120,width: 24,height: 24},
{name:'union_with_under',x: 96,y: 120,width: 24,height: 24},
{name:'union_with_over_under',x: 120,y: 120,width: 24,height: 24},
{name:'intersect_with_none',x: 144,y: 120,width: 24,height: 24},
{name:'intersect_with_sub',x: 168,y: 120,width: 24,height: 24},
{name:'intersect_with_super',x: 192,y: 120,width: 24,height: 24},
{name:'intersect_with_sub_sup',x: 216,y: 120,width: 24,height: 24},
{name:'intersect_with_over',x: 240,y: 120,width: 24,height: 24},
{name:'intersect_with_under',x: 264,y: 120,width: 24,height: 24},
{name:'intersect_with_over_under',x: 288,y: 120,width: 24,height: 24},
{name:'and_with_none',x: 312,y: 120,width: 24,height: 24},
{name:'and_with_sub',x: 336,y: 120,width: 24,height: 24},
{name:'and_with_super',x: 360,y: 120,width: 24,height: 24},
{name:'and_with_sub_sup',x: 384,y: 120,width: 24,height: 24},
{name:'and_with_over',x: 408,y: 120,width: 24,height: 24},
{name:'and_with_under',x: 432,y: 120,width: 24,height: 24},
{name:'and_with_over_under',x: 456,y: 120,width: 24,height: 24},
{name:'or_with_none',x: 480,y: 120,width: 24,height: 24},
{name:'or_with_sub',x: 504,y: 120,width: 24,height: 24},
{name:'or_with_super',x: 528,y: 120,width: 24,height: 24},
{name:'or_with_sub_sup',x: 552,y: 120,width: 24,height: 24},
{name:'or_with_over',x: 576,y: 120,width: 24,height: 24},
{name:'or_with_under',x: 600,y: 120,width: 24,height: 24},
{name:'or_with_over_under',x: 624,y: 120,width: 24,height: 24},
]},
{menu: 'integral',x: 648,y: 120,width: 54,height: 24,
items: [{name:'integral_with_over',x: 702,y: 120,width: 24,height: 24},
{name:'integral_with_under',x: 726,y: 120,width: 24,height: 24},
{name:'integral_with_over_under',x: 750,y: 120,width: 24,height: 24},
{name:'integral_with_none',x: 774,y: 120,width: 24,height: 24},
{name:'integral_with_sub',x: 0,y: 144,width: 24,height: 24},
{name:'integral_with_super',x: 24,y: 144,width: 24,height: 24},
{name:'integral_with_sub_sup',x: 48,y: 144,width: 24,height: 24},
{name:'double_integral_with_over',x: 72,y: 144,width: 24,height: 24},
{name:'double_integral_with_under',x: 96,y: 144,width: 24,height: 24},
{name:'double_integral_with_over_under',x: 120,y: 144,width: 24,height: 24},
{name:'double_line_integral_with_over',x: 144,y: 144,width: 24,height: 24},
{name:'double_line_integral_with_under',x: 168,y: 144,width: 24,height: 24},
{name:'double_line_integral_with_over_under',x: 192,y: 144,width: 24,height: 24},
{name:'double_integral_with_none',x: 216,y: 144,width: 24,height: 24},
{name:'double_integral_with_sub',x: 240,y: 144,width: 24,height: 24},
{name:'double_integral_with_super',x: 264,y: 144,width: 24,height: 24},
{name:'double_integral_with_sub_sup',x: 288,y: 144,width: 24,height: 24},
{name:'double_line_integral_with_none',x: 312,y: 144,width: 24,height: 24},
{name:'double_line_integral_with_sub',x: 336,y: 144,width: 24,height: 24},
{name:'double_line_integral_with_super',x: 360,y: 144,width: 24,height: 24},
{name:'double_line_integral_with_sub_sup',x: 384,y: 144,width: 24,height: 24},
{name:'triple_integral_with_over',x: 408,y: 144,width: 24,height: 24},
{name:'triple_integral_with_under',x: 432,y: 144,width: 24,height: 24},
{name:'triple_integral_with_over_under',x: 456,y: 144,width: 24,height: 24},
{name:'triple_line_integral_with_over',x: 480,y: 144,width: 24,height: 24},
{name:'triple_line_integral_with_under',x: 504,y: 144,width: 24,height: 24},
{name:'triple_line_integral_with_over_under',x: 528,y: 144,width: 24,height: 24},
{name:'triple_integral_with_none',x: 552,y: 144,width: 24,height: 24},
{name:'triple_integral_with_sub',x: 576,y: 144,width: 24,height: 24},
{name:'triple_integral_with_super',x: 600,y: 144,width: 24,height: 24},
{name:'triple_integral_with_sub_sup',x: 624,y: 144,width: 24,height: 24},
{name:'triple_line_integral_with_none',x: 648,y: 144,width: 24,height: 24},
{name:'triple_line_integral_with_sub',x: 672,y: 144,width: 24,height: 24},
{name:'triple_line_integral_with_super',x: 696,y: 144,width: 24,height: 24},
{name:'triple_line_integral_with_sub_sup',x: 720,y: 144,width: 24,height: 24},
{name:'line_integral_with_over',x: 744,y: 144,width: 24,height: 24},
{name:'line_integral_with_under',x: 768,y: 144,width: 24,height: 24},
{name:'line_integral_with_over_under',x: 0,y: 168,width: 24,height: 24},
{name:'line_integral_with_none',x: 24,y: 168,width: 24,height: 24},
{name:'line_integral_with_sub',x: 48,y: 168,width: 24,height: 24},
{name:'line_integral_with_super',x: 72,y: 168,width: 24,height: 24},
{name:'line_integral_with_sub_sup',x: 96,y: 168,width: 24,height: 24},
{name:'clockwise_contour_integral_with_over',x: 120,y: 168,width: 24,height: 24},
{name:'clockwise_contour_integral_with_under',x: 144,y: 168,width: 24,height: 24},
{name:'clockwise_contour_integral_with_over_under',x: 168,y: 168,width: 24,height: 24},
{name:'clockwise_contour_integral_with_none',x: 192,y: 168,width: 24,height: 24},
{name:'clockwise_contour_integral_with_sub',x: 216,y: 168,width: 24,height: 24},
{name:'clockwise_contour_integral_with_super',x: 240,y: 168,width: 24,height: 24},
{name:'clockwise_contour_integral_with_sub_sup',x: 264,y: 168,width: 24,height: 24},
{name:'counter_clockwise_contour_integral_with_over',x: 288,y: 168,width: 24,height: 24},
{name:'counter_clockwise_contour_integral_with_under',x: 312,y: 168,width: 24,height: 24},
{name:'counter_clockwise_contour_integral_with_over_under',x: 336,y: 168,width: 24,height: 24},
{name:'counter_clockwise_contour_integral_with_none',x: 360,y: 168,width: 24,height: 24},
{name:'counter_clockwise_contour_integral_with_sub',x: 384,y: 168,width: 24,height: 24},
{name:'counter_clockwise_contour_integral_with_super',x: 408,y: 168,width: 24,height: 24},
{name:'counter_clockwise_contour_integral_with_sub_sup',x: 432,y: 168,width: 24,height: 24},
]},
{menu: 'oversymbol',x: 456,y: 168,width: 54,height: 24,
items: [{name:'over_1dot',x: 510,y: 168,width: 24,height: 24},
{name:'over_2dot',x: 534,y: 168,width: 24,height: 24},
{name:'over_3dot',x: 558,y: 168,width: 24,height: 24},
{name:'super_prime',x: 582,y: 168,width: 24,height: 24},
{name:'super_double_prime',x: 606,y: 168,width: 24,height: 24},
{name:'super_triple_prime',x: 630,y: 168,width: 24,height: 24},
{name:'over_prime',x: 654,y: 168,width: 24,height: 24},
{name:'over_double_prime',x: 678,y: 168,width: 24,height: 24},
{name:'over_triple_prime',x: 702,y: 168,width: 24,height: 24},
{name:'left_super_reverse_prime',x: 726,y: 168,width: 24,height: 24},
{name:'over_tilde',x: 750,y: 168,width: 24,height: 24},
{name:'over_cap',x: 774,y: 168,width: 24,height: 24},
{name:'over_reverse_cap',x: 0,y: 192,width: 24,height: 24},
{name:'over_brever',x: 24,y: 192,width: 24,height: 24},
{name:'over_reverse_breve',x: 48,y: 192,width: 24,height: 24},
{name:'over_ring',x: 72,y: 192,width: 24,height: 24},
{name:'super_ring',x: 96,y: 192,width: 24,height: 24},
{name:'sub_ring',x: 120,y: 192,width: 24,height: 24},
{name:'under_1dot',x: 144,y: 192,width: 24,height: 24},
{name:'under_2dot',x: 168,y: 192,width: 24,height: 24},
{name:'under_3dot',x: 192,y: 192,width: 24,height: 24},
{name:'under_tilde',x: 216,y: 192,width: 24,height: 24},
{name:'under_cap',x: 240,y: 192,width: 24,height: 24},
{name:'under_reverse_cap',x: 264,y: 192,width: 24,height: 24},
{name:'under_brever',x: 288,y: 192,width: 24,height: 24},
{name:'under_reverse_breve',x: 312,y: 192,width: 24,height: 24},
{name:'under_ring',x: 336,y: 192,width: 24,height: 24},
{name:'over_line',x: 360,y: 192,width: 24,height: 24},
{name:'over_double_line',x: 384,y: 192,width: 24,height: 24},
{name:'over_left_arrow',x: 408,y: 192,width: 24,height: 24},
{name:'over_right_arrow',x: 432,y: 192,width: 24,height: 24},
{name:'over_left_right_arrow',x: 456,y: 192,width: 24,height: 24},
{name:'over_left_single_arrow',x: 480,y: 192,width: 24,height: 24},
{name:'over_right_single_arrow',x: 504,y: 192,width: 24,height: 24},
{name:'under_line',x: 528,y: 192,width: 24,height: 24},
{name:'under_double_line',x: 552,y: 192,width: 24,height: 24},
{name:'under_left_arrow',x: 576,y: 192,width: 24,height: 24},
{name:'under_right_arrow',x: 600,y: 192,width: 24,height: 24},
{name:'under_left_right_arrow',x: 624,y: 192,width: 24,height: 24},
{name:'under_left_single_arrow',x: 648,y: 192,width: 24,height: 24},
{name:'under_right_single_arrow',x: 672,y: 192,width: 24,height: 24},
]},
{menu: 'matrix',x: 696,y: 192,width: 54,height: 24,
items: [{name:'matrix_1x2',x: 750,y: 192,width: 24,height: 24},
{name:'matrix_2x1',x: 774,y: 192,width: 24,height: 24},
{name:'matrix_2x2',x: 0,y: 216,width: 24,height: 24},
{name:'matrix_1x3',x: 24,y: 216,width: 24,height: 24},
{name:'matrix_3x1',x: 48,y: 216,width: 24,height: 24},
{name:'matrix_3x3',x: 72,y: 216,width: 24,height: 24},
{name:'matrix_1x4',x: 96,y: 216,width: 24,height: 24},
{name:'matrix_4x1',x: 120,y: 216,width: 24,height: 24},
{name:'matrix_4x4',x: 144,y: 216,width: 24,height: 24},
{name:'matrix_2x3',x: 168,y: 216,width: 24,height: 24},
{name:'matrix_3x2',x: 192,y: 216,width: 24,height: 24},
{name:'matrix_3x4',x: 216,y: 216,width: 24,height: 24},
{name:'matrix_4x3',x: 240,y: 216,width: 24,height: 24},
]},
{menu: 'space',x: 264,y: 216,width: 54,height: 24,
items: [{name:'space3',x: 318,y: 216,width: 44,height: 24},
{name:'space4',x: 362,y: 216,width: 44,height: 24},
{name:'space5',x: 406,y: 216,width: 44,height: 24},
{name:'space-3',x: 450,y: 216,width: 44,height: 24},
{name:'space18',x: 494,y: 216,width: 44,height: 24},
{name:'space36',x: 538,y: 216,width: 44,height: 24},
]},
{menu: 'grksmall',x: 582,y: 216,width: 54,height: 24,
items: [{name:'symbol_grk_small_0',x: 636,y: 216,width: 24,height: 24},
{name:'symbol_grk_small_1',x: 660,y: 216,width: 24,height: 24},
{name:'symbol_grk_small_2',x: 684,y: 216,width: 24,height: 24},
{name:'symbol_grk_small_3',x: 708,y: 216,width: 24,height: 24},
{name:'symbol_grk_small_4',x: 732,y: 216,width: 24,height: 24},
{name:'symbol_grk_small_5',x: 756,y: 216,width: 24,height: 24},
{name:'symbol_grk_small_6',x: 0,y: 240,width: 24,height: 24},
{name:'symbol_grk_small_7',x: 24,y: 240,width: 24,height: 24},
{name:'symbol_grk_small_8',x: 48,y: 240,width: 24,height: 24},
{name:'symbol_grk_small_9',x: 72,y: 240,width: 24,height: 24},
{name:'symbol_grk_small_10',x: 96,y: 240,width: 24,height: 24},
{name:'symbol_grk_small_11',x: 120,y: 240,width: 24,height: 24},
{name:'symbol_grk_small_12',x: 144,y: 240,width: 24,height: 24},
{name:'symbol_grk_small_13',x: 168,y: 240,width: 24,height: 24},
{name:'symbol_grk_small_14',x: 192,y: 240,width: 24,height: 24},
{name:'symbol_grk_small_15',x: 216,y: 240,width: 24,height: 24},
{name:'symbol_grk_small_16',x: 240,y: 240,width: 24,height: 24},
{name:'symbol_grk_small_17',x: 264,y: 240,width: 24,height: 24},
{name:'symbol_grk_small_18',x: 288,y: 240,width: 24,height: 24},
{name:'symbol_grk_small_19',x: 312,y: 240,width: 24,height: 24},
{name:'symbol_grk_small_20',x: 336,y: 240,width: 24,height: 24},
{name:'symbol_grk_small_21',x: 360,y: 240,width: 24,height: 24},
{name:'symbol_grk_small_22',x: 384,y: 240,width: 24,height: 24},
{name:'symbol_grk_small_23',x: 408,y: 240,width: 24,height: 24},
{name:'symbol_grk_small_24',x: 432,y: 240,width: 24,height: 24},
{name:'symbol_grk_small_25',x: 456,y: 240,width: 24,height: 24},
{name:'symbol_grk_small_26',x: 480,y: 240,width: 24,height: 24},
{name:'symbol_grk_small_27',x: 504,y: 240,width: 24,height: 24},
{name:'symbol_grk_small_28',x: 528,y: 240,width: 24,height: 24},
{name:'symbol_grk_small_29',x: 552,y: 240,width: 24,height: 24},
{name:'symbol_grk_small_30',x: 576,y: 240,width: 24,height: 24},
{name:'symbol_grk_small_31',x: 600,y: 240,width: 24,height: 24},
]},
{menu: 'grklarge',x: 624,y: 240,width: 54,height: 24,
items: [{name:'symbol_grk_large_0',x: 678,y: 240,width: 24,height: 24},
{name:'symbol_grk_large_1',x: 702,y: 240,width: 24,height: 24},
{name:'symbol_grk_large_2',x: 726,y: 240,width: 24,height: 24},
{name:'symbol_grk_large_3',x: 750,y: 240,width: 24,height: 24},
{name:'symbol_grk_large_4',x: 774,y: 240,width: 24,height: 24},
{name:'symbol_grk_large_5',x: 0,y: 264,width: 24,height: 24},
{name:'symbol_grk_large_6',x: 24,y: 264,width: 24,height: 24},
{name:'symbol_grk_large_7',x: 48,y: 264,width: 24,height: 24},
{name:'symbol_grk_large_8',x: 72,y: 264,width: 24,height: 24},
{name:'symbol_grk_large_9',x: 96,y: 264,width: 24,height: 24},
{name:'symbol_grk_large_10',x: 120,y: 264,width: 24,height: 24},
{name:'symbol_grk_large_11',x: 144,y: 264,width: 24,height: 24},
{name:'symbol_grk_large_12',x: 168,y: 264,width: 24,height: 24},
{name:'symbol_grk_large_13',x: 192,y: 264,width: 24,height: 24},
{name:'symbol_grk_large_14',x: 216,y: 264,width: 24,height: 24},
{name:'symbol_grk_large_15',x: 240,y: 264,width: 24,height: 24},
{name:'symbol_grk_large_16',x: 264,y: 264,width: 24,height: 24},
{name:'symbol_grk_large_17',x: 288,y: 264,width: 24,height: 24},
{name:'symbol_grk_large_18',x: 312,y: 264,width: 24,height: 24},
{name:'symbol_grk_large_19',x: 336,y: 264,width: 24,height: 24},
{name:'symbol_grk_large_20',x: 360,y: 264,width: 24,height: 24},
{name:'symbol_grk_large_21',x: 384,y: 264,width: 24,height: 24},
{name:'symbol_grk_large_22',x: 408,y: 264,width: 24,height: 24},
{name:'symbol_grk_large_23',x: 432,y: 264,width: 24,height: 24},
{name:'symbol_grk_large_24',x: 456,y: 264,width: 24,height: 24},
{name:'symbol_grk_large_25',x: 480,y: 264,width: 24,height: 24},
]},
{menu: 'symbol_arrow',x: 504,y: 264,width: 54,height: 24,
items: [{name:'symbol_arrow_0',x: 558,y: 264,width: 24,height: 24},
{name:'symbol_arrow_1',x: 582,y: 264,width: 24,height: 24},
{name:'symbol_arrow_2',x: 606,y: 264,width: 24,height: 24},
{name:'symbol_arrow_3',x: 630,y: 264,width: 24,height: 24},
{name:'symbol_arrow_4',x: 654,y: 264,width: 24,height: 24},
{name:'symbol_arrow_5',x: 678,y: 264,width: 24,height: 24},
{name:'symbol_arrow_6',x: 702,y: 264,width: 24,height: 24},
{name:'symbol_arrow_7',x: 726,y: 264,width: 24,height: 24},
{name:'symbol_arrow_8',x: 750,y: 264,width: 24,height: 24},
{name:'symbol_arrow_9',x: 774,y: 264,width: 24,height: 24},
{name:'symbol_arrow_10',x: 0,y: 288,width: 24,height: 24},
{name:'symbol_arrow_11',x: 24,y: 288,width: 24,height: 24},
{name:'symbol_arrow_12',x: 48,y: 288,width: 24,height: 24},
{name:'symbol_arrow_13',x: 72,y: 288,width: 24,height: 24},
{name:'symbol_arrow_14',x: 96,y: 288,width: 24,height: 24},
{name:'symbol_arrow_15',x: 120,y: 288,width: 24,height: 24},
{name:'symbol_arrow_16',x: 144,y: 288,width: 24,height: 24},
{name:'symbol_arrow_17',x: 168,y: 288,width: 24,height: 24},
{name:'symbol_arrow_18',x: 192,y: 288,width: 24,height: 24},
{name:'symbol_arrow_19',x: 216,y: 288,width: 24,height: 24},
{name:'symbol_arrow_20',x: 240,y: 288,width: 24,height: 24},
{name:'symbol_arrow_21',x: 264,y: 288,width: 24,height: 24},
{name:'symbol_arrow_22',x: 288,y: 288,width: 24,height: 24},
{name:'symbol_arrow_23',x: 312,y: 288,width: 24,height: 24},
{name:'symbol_arrow_24',x: 336,y: 288,width: 24,height: 24},
{name:'symbol_arrow_25',x: 360,y: 288,width: 24,height: 24},
{name:'symbol_arrow_26',x: 384,y: 288,width: 24,height: 24},
{name:'symbol_arrow_27',x: 408,y: 288,width: 24,height: 24},
{name:'symbol_arrow_28',x: 432,y: 288,width: 24,height: 24},
{name:'symbol_arrow_29',x: 456,y: 288,width: 24,height: 24},
{name:'symbol_arrow_30',x: 480,y: 288,width: 24,height: 24},
{name:'symbol_arrow_31',x: 504,y: 288,width: 24,height: 24},
{name:'symbol_arrow_32',x: 528,y: 288,width: 24,height: 24},
{name:'symbol_arrow_33',x: 552,y: 288,width: 24,height: 24},
{name:'symbol_arrow_34',x: 576,y: 288,width: 24,height: 24},
{name:'symbol_arrow_35',x: 600,y: 288,width: 24,height: 24},
{name:'symbol_arrow_36',x: 624,y: 288,width: 24,height: 24},
{name:'symbol_arrow_37',x: 648,y: 288,width: 24,height: 24},
{name:'symbol_arrow_38',x: 672,y: 288,width: 24,height: 24},
{name:'symbol_arrow_39',x: 696,y: 288,width: 24,height: 24},
{name:'symbol_arrow_40',x: 720,y: 288,width: 24,height: 24},
{name:'symbol_arrow_41',x: 744,y: 288,width: 24,height: 24},
{name:'symbol_arrow_42',x: 768,y: 288,width: 24,height: 24},
{name:'symbol_arrow_43',x: 0,y: 312,width: 24,height: 24},
{name:'symbol_arrow_44',x: 24,y: 312,width: 24,height: 24},
{name:'symbol_arrow_45',x: 48,y: 312,width: 24,height: 24},
{name:'symbol_arrow_46',x: 72,y: 312,width: 24,height: 24},
{name:'symbol_arrow_47',x: 96,y: 312,width: 24,height: 24},
{name:'symbol_arrow_48',x: 120,y: 312,width: 24,height: 24},
{name:'symbol_arrow_49',x: 144,y: 312,width: 24,height: 24},
{name:'symbol_arrow_50',x: 168,y: 312,width: 24,height: 24},
{name:'symbol_arrow_51',x: 192,y: 312,width: 24,height: 24},
{name:'symbol_arrow_52',x: 216,y: 312,width: 24,height: 24},
{name:'symbol_arrow_53',x: 240,y: 312,width: 24,height: 24},
{name:'symbol_arrow_54',x: 264,y: 312,width: 24,height: 24},
{name:'symbol_arrow_55',x: 288,y: 312,width: 24,height: 24},
{name:'symbol_arrow_56',x: 312,y: 312,width: 24,height: 24},
{name:'symbol_arrow_57',x: 336,y: 312,width: 24,height: 24},
{name:'symbol_arrow_58',x: 360,y: 312,width: 24,height: 24},
{name:'symbol_arrow_59',x: 384,y: 312,width: 24,height: 24},
{name:'symbol_arrow_60',x: 408,y: 312,width: 24,height: 24},
{name:'symbol_arrow_61',x: 432,y: 312,width: 24,height: 24},
{name:'symbol_arrow_62',x: 456,y: 312,width: 24,height: 24},
{name:'symbol_arrow_63',x: 480,y: 312,width: 24,height: 24},
{name:'symbol_arrow_64',x: 504,y: 312,width: 24,height: 24},
{name:'symbol_arrow_65',x: 528,y: 312,width: 24,height: 24},
{name:'symbol_arrow_66',x: 552,y: 312,width: 24,height: 24},
{name:'symbol_arrow_67',x: 576,y: 312,width: 24,height: 24},
{name:'symbol_arrow_68',x: 600,y: 312,width: 24,height: 24},
{name:'symbol_arrow_69',x: 624,y: 312,width: 24,height: 24},
{name:'symbol_arrow_70',x: 648,y: 312,width: 24,height: 24},
{name:'symbol_arrow_71',x: 672,y: 312,width: 24,height: 24},
{name:'symbol_arrow_72',x: 696,y: 312,width: 24,height: 24},
{name:'symbol_arrow_73',x: 720,y: 312,width: 24,height: 24},
{name:'symbol_arrow_74',x: 744,y: 312,width: 24,height: 24},
{name:'symbol_arrow_75',x: 768,y: 312,width: 24,height: 24},
{name:'symbol_arrow_76',x: 0,y: 336,width: 24,height: 24},
{name:'symbol_arrow_77',x: 24,y: 336,width: 24,height: 24},
{name:'symbol_arrow_78',x: 48,y: 336,width: 24,height: 24},
{name:'symbol_arrow_79',x: 72,y: 336,width: 24,height: 24},
{name:'symbol_arrow_80',x: 96,y: 336,width: 24,height: 24},
{name:'symbol_arrow_81',x: 120,y: 336,width: 24,height: 24},
{name:'symbol_arrow_82',x: 144,y: 336,width: 24,height: 24},
{name:'symbol_arrow_83',x: 168,y: 336,width: 24,height: 24},
{name:'symbol_arrow_84',x: 192,y: 336,width: 24,height: 24},
{name:'symbol_arrow_85',x: 216,y: 336,width: 24,height: 24},
{name:'symbol_arrow_86',x: 240,y: 336,width: 24,height: 24},
{name:'symbol_arrow_87',x: 264,y: 336,width: 24,height: 24},
{name:'symbol_arrow_88',x: 288,y: 336,width: 24,height: 24},
{name:'symbol_arrow_89',x: 312,y: 336,width: 24,height: 24},
]},
{menu: 'symbol_shape',x: 336,y: 336,width: 54,height: 24,
items: [{name:'symbol_shape_0',x: 390,y: 336,width: 24,height: 24},
{name:'symbol_shape_1',x: 414,y: 336,width: 24,height: 24},
{name:'symbol_shape_2',x: 438,y: 336,width: 24,height: 24},
{name:'symbol_shape_3',x: 462,y: 336,width: 24,height: 24},
{name:'symbol_shape_4',x: 486,y: 336,width: 24,height: 24},
{name:'symbol_shape_5',x: 510,y: 336,width: 24,height: 24},
{name:'symbol_shape_6',x: 534,y: 336,width: 24,height: 24},
{name:'symbol_shape_7',x: 558,y: 336,width: 24,height: 24},
{name:'symbol_shape_8',x: 582,y: 336,width: 24,height: 24},
{name:'symbol_shape_9',x: 606,y: 336,width: 24,height: 24},
{name:'symbol_shape_10',x: 630,y: 336,width: 24,height: 24},
{name:'symbol_shape_11',x: 654,y: 336,width: 24,height: 24},
{name:'symbol_shape_12',x: 678,y: 336,width: 24,height: 24},
{name:'symbol_shape_13',x: 702,y: 336,width: 24,height: 24},
{name:'symbol_shape_14',x: 726,y: 336,width: 24,height: 24},
{name:'symbol_shape_15',x: 750,y: 336,width: 24,height: 24},
{name:'symbol_shape_16',x: 774,y: 336,width: 24,height: 24},
{name:'symbol_shape_17',x: 0,y: 360,width: 24,height: 24},
{name:'symbol_shape_18',x: 24,y: 360,width: 24,height: 24},
{name:'symbol_shape_19',x: 48,y: 360,width: 24,height: 24},
{name:'symbol_shape_20',x: 72,y: 360,width: 24,height: 24},
{name:'symbol_shape_21',x: 96,y: 360,width: 24,height: 24},
{name:'symbol_shape_22',x: 120,y: 360,width: 24,height: 24},
{name:'symbol_shape_23',x: 144,y: 360,width: 24,height: 24},
{name:'symbol_shape_24',x: 168,y: 360,width: 24,height: 24},
]},
{menu: 'symbol_op',x: 192,y: 360,width: 54,height: 24,
items: [{name:'symbol_op_basic_0',x: 246,y: 360,width: 24,height: 24},
{name:'symbol_op_basic_1',x: 270,y: 360,width: 24,height: 24},
{name:'symbol_op_basic_2',x: 294,y: 360,width: 24,height: 24},
{name:'symbol_op_basic_3',x: 318,y: 360,width: 24,height: 24},
{name:'symbol_op_basic_4',x: 342,y: 360,width: 24,height: 24},
{name:'symbol_op_basic_5',x: 366,y: 360,width: 24,height: 24},
{name:'symbol_op_basic_6',x: 390,y: 360,width: 24,height: 24},
{name:'symbol_op_basic_7',x: 414,y: 360,width: 24,height: 24},
{name:'symbol_op_basic_8',x: 438,y: 360,width: 24,height: 24},
{name:'symbol_op_basic_9',x: 462,y: 360,width: 24,height: 24},
{name:'symbol_op_0',x: 486,y: 360,width: 24,height: 24},
{name:'symbol_op_1',x: 510,y: 360,width: 24,height: 24},
{name:'symbol_op_2',x: 534,y: 360,width: 24,height: 24},
{name:'symbol_op_3',x: 558,y: 360,width: 24,height: 24},
{name:'symbol_op_4',x: 582,y: 360,width: 24,height: 24},
{name:'symbol_op_5',x: 606,y: 360,width: 24,height: 24},
{name:'symbol_op_6',x: 630,y: 360,width: 24,height: 24},
{name:'symbol_op_7',x: 654,y: 360,width: 24,height: 24},
{name:'symbol_op_8',x: 678,y: 360,width: 24,height: 24},
{name:'symbol_op_9',x: 702,y: 360,width: 24,height: 24},
{name:'symbol_op_10',x: 726,y: 360,width: 24,height: 24},
{name:'symbol_op_11',x: 750,y: 360,width: 24,height: 24},
{name:'symbol_op_12',x: 774,y: 360,width: 24,height: 24},
{name:'symbol_op_13',x: 0,y: 384,width: 24,height: 24},
{name:'symbol_op_14',x: 24,y: 384,width: 24,height: 24},
{name:'symbol_op_15',x: 48,y: 384,width: 24,height: 24},
{name:'symbol_op_16',x: 72,y: 384,width: 24,height: 24},
{name:'symbol_op_17',x: 96,y: 384,width: 24,height: 24},
{name:'symbol_op_18',x: 120,y: 384,width: 24,height: 24},
{name:'symbol_op_19',x: 144,y: 384,width: 24,height: 24},
{name:'symbol_op_20',x: 168,y: 384,width: 24,height: 24},
{name:'symbol_op_21',x: 192,y: 384,width: 24,height: 24},
{name:'symbol_op_22',x: 216,y: 384,width: 24,height: 24},
{name:'symbol_op_23',x: 240,y: 384,width: 24,height: 24},
{name:'symbol_op_24',x: 264,y: 384,width: 24,height: 24},
{name:'symbol_op_25',x: 288,y: 384,width: 24,height: 24},
{name:'symbol_op_26',x: 312,y: 384,width: 24,height: 24},
{name:'symbol_op_27',x: 336,y: 384,width: 24,height: 24},
{name:'symbol_op_28',x: 360,y: 384,width: 24,height: 24},
{name:'symbol_op_29',x: 384,y: 384,width: 24,height: 24},
{name:'symbol_op_30',x: 408,y: 384,width: 24,height: 24},
{name:'symbol_op_31',x: 432,y: 384,width: 24,height: 24},
{name:'symbol_op_32',x: 456,y: 384,width: 24,height: 24},
{name:'symbol_op_33',x: 480,y: 384,width: 24,height: 24},
{name:'symbol_op_34',x: 504,y: 384,width: 24,height: 24},
{name:'symbol_op_35',x: 528,y: 384,width: 24,height: 24},
{name:'symbol_op_36',x: 552,y: 384,width: 24,height: 24},
{name:'symbol_op_37',x: 576,y: 384,width: 24,height: 24},
{name:'symbol_op_38',x: 600,y: 384,width: 24,height: 24},
{name:'symbol_op_39',x: 624,y: 384,width: 24,height: 24},
{name:'symbol_op_40',x: 648,y: 384,width: 24,height: 24},
{name:'symbol_op_41',x: 672,y: 384,width: 24,height: 24},
{name:'symbol_op_42',x: 696,y: 384,width: 24,height: 24},
{name:'symbol_op_43',x: 720,y: 384,width: 24,height: 24},
{name:'symbol_op_44',x: 744,y: 384,width: 24,height: 24},
{name:'symbol_op_45',x: 768,y: 384,width: 24,height: 24},
]},
{menu: 'symbol_op2',x: 0,y: 408,width: 54,height: 24,
items: [{name:'symbol_op_46',x: 54,y: 408,width: 24,height: 24},
{name:'symbol_op_47',x: 78,y: 408,width: 24,height: 24},
{name:'symbol_op_48',x: 102,y: 408,width: 24,height: 24},
{name:'symbol_op_49',x: 126,y: 408,width: 24,height: 24},
{name:'symbol_op_50',x: 150,y: 408,width: 24,height: 24},
{name:'symbol_op_51',x: 174,y: 408,width: 24,height: 24},
{name:'symbol_op_52',x: 198,y: 408,width: 24,height: 24},
{name:'symbol_op_53',x: 222,y: 408,width: 24,height: 24},
{name:'symbol_op_54',x: 246,y: 408,width: 24,height: 24},
{name:'symbol_op_55',x: 270,y: 408,width: 24,height: 24},
{name:'symbol_op_56',x: 294,y: 408,width: 24,height: 24},
{name:'symbol_op_57',x: 318,y: 408,width: 24,height: 24},
{name:'symbol_op_58',x: 342,y: 408,width: 24,height: 24},
{name:'symbol_op_59',x: 366,y: 408,width: 24,height: 24},
{name:'symbol_op_60',x: 390,y: 408,width: 24,height: 24},
{name:'symbol_op_61',x: 414,y: 408,width: 24,height: 24},
{name:'symbol_op_62',x: 438,y: 408,width: 24,height: 24},
{name:'symbol_op_63',x: 462,y: 408,width: 24,height: 24},
{name:'symbol_op_64',x: 486,y: 408,width: 24,height: 24},
{name:'symbol_op_65',x: 510,y: 408,width: 24,height: 24},
{name:'symbol_op_66',x: 534,y: 408,width: 24,height: 24},
{name:'symbol_op_67',x: 558,y: 408,width: 24,height: 24},
{name:'symbol_op_68',x: 582,y: 408,width: 24,height: 24},
{name:'symbol_op_69',x: 606,y: 408,width: 24,height: 24},
{name:'symbol_op_70',x: 630,y: 408,width: 24,height: 24},
{name:'symbol_op_71',x: 654,y: 408,width: 24,height: 24},
{name:'symbol_op_72',x: 678,y: 408,width: 24,height: 24},
{name:'symbol_op_73',x: 702,y: 408,width: 24,height: 24},
{name:'symbol_op_74',x: 726,y: 408,width: 24,height: 24},
{name:'symbol_op_75',x: 750,y: 408,width: 24,height: 24},
{name:'symbol_op_76',x: 774,y: 408,width: 24,height: 24},
{name:'symbol_op_77',x: 0,y: 432,width: 24,height: 24},
{name:'symbol_op_78',x: 24,y: 432,width: 24,height: 24},
{name:'symbol_op_79',x: 48,y: 432,width: 24,height: 24},
{name:'symbol_op_80',x: 72,y: 432,width: 24,height: 24},
{name:'symbol_op_81',x: 96,y: 432,width: 24,height: 24},
{name:'symbol_op_82',x: 120,y: 432,width: 24,height: 24},
{name:'symbol_op_83',x: 144,y: 432,width: 24,height: 24},
{name:'symbol_op_84',x: 168,y: 432,width: 24,height: 24},
{name:'symbol_op_85',x: 192,y: 432,width: 24,height: 24},
{name:'symbol_op_86',x: 216,y: 432,width: 24,height: 24},
{name:'symbol_op_87',x: 240,y: 432,width: 24,height: 24},
{name:'symbol_op_88',x: 264,y: 432,width: 24,height: 24},
{name:'symbol_op_89',x: 288,y: 432,width: 24,height: 24},
{name:'symbol_op_90',x: 312,y: 432,width: 24,height: 24},
{name:'symbol_op_91',x: 336,y: 432,width: 24,height: 24},
{name:'symbol_op_92',x: 360,y: 432,width: 24,height: 24},
{name:'symbol_op_93',x: 384,y: 432,width: 24,height: 24},
{name:'symbol_op_94',x: 408,y: 432,width: 24,height: 24},
{name:'symbol_op_95',x: 432,y: 432,width: 24,height: 24},
{name:'symbol_op_96',x: 456,y: 432,width: 24,height: 24},
{name:'symbol_op_97',x: 480,y: 432,width: 24,height: 24},
{name:'symbol_op_98',x: 504,y: 432,width: 24,height: 24},
{name:'symbol_op_99',x: 528,y: 432,width: 24,height: 24},
{name:'symbol_op_100',x: 552,y: 432,width: 24,height: 24},
{name:'symbol_op_101',x: 576,y: 432,width: 24,height: 24},
{name:'symbol_op_102',x: 600,y: 432,width: 24,height: 24},
{name:'symbol_op_103',x: 624,y: 432,width: 24,height: 24},
{name:'symbol_op_104',x: 648,y: 432,width: 24,height: 24},
{name:'symbol_op_105',x: 672,y: 432,width: 24,height: 24},
{name:'symbol_op_106',x: 696,y: 432,width: 24,height: 24},
{name:'symbol_op_107',x: 720,y: 432,width: 24,height: 24},
{name:'symbol_op_108',x: 744,y: 432,width: 24,height: 24},
{name:'symbol_op_109',x: 768,y: 432,width: 24,height: 24},
{name:'symbol_op_110',x: 0,y: 456,width: 24,height: 24},
{name:'symbol_op_111',x: 24,y: 456,width: 24,height: 24},
{name:'symbol_op_112',x: 48,y: 456,width: 24,height: 24},
{name:'symbol_op_113',x: 72,y: 456,width: 24,height: 24},
{name:'symbol_op_114',x: 96,y: 456,width: 24,height: 24},
{name:'symbol_op_115',x: 120,y: 456,width: 24,height: 24},
{name:'symbol_op_116',x: 144,y: 456,width: 24,height: 24},
{name:'symbol_op_117',x: 168,y: 456,width: 24,height: 24},
{name:'symbol_op_118',x: 192,y: 456,width: 24,height: 24},
{name:'symbol_op_119',x: 216,y: 456,width: 24,height: 24},
{name:'symbol_op_120',x: 240,y: 456,width: 24,height: 24},
{name:'symbol_op_121',x: 264,y: 456,width: 24,height: 24},
{name:'symbol_op_122',x: 288,y: 456,width: 24,height: 24},
{name:'symbol_op_123',x: 312,y: 456,width: 24,height: 24},
{name:'symbol_op_124',x: 336,y: 456,width: 24,height: 24},
{name:'symbol_op_125',x: 360,y: 456,width: 24,height: 24},
{name:'symbol_op_126',x: 384,y: 456,width: 24,height: 24},
{name:'symbol_op_127',x: 408,y: 456,width: 24,height: 24},
{name:'symbol_op_128',x: 432,y: 456,width: 24,height: 24},
{name:'symbol_op_129',x: 456,y: 456,width: 24,height: 24},
{name:'symbol_op_130',x: 480,y: 456,width: 24,height: 24},
{name:'symbol_op_131',x: 504,y: 456,width: 24,height: 24},
]},
{menu: 'letter',x: 528,y: 456,width: 54,height: 24,
items: [{name:'symbol_letters_0',x: 582,y: 456,width: 24,height: 24},
{name:'symbol_letters_1',x: 606,y: 456,width: 24,height: 24},
{name:'symbol_letters_2',x: 630,y: 456,width: 24,height: 24},
{name:'symbol_letters_3',x: 654,y: 456,width: 24,height: 24},
{name:'symbol_letters_4',x: 678,y: 456,width: 24,height: 24},
{name:'symbol_letters_5',x: 702,y: 456,width: 24,height: 24},
{name:'symbol_letters_6',x: 726,y: 456,width: 24,height: 24},
{name:'symbol_letters_7',x: 750,y: 456,width: 24,height: 24},
{name:'symbol_letters_8',x: 774,y: 456,width: 24,height: 24},
{name:'symbol_letters_9',x: 0,y: 480,width: 24,height: 24},
{name:'symbol_letters_10',x: 24,y: 480,width: 24,height: 24},
{name:'symbol_letters_11',x: 48,y: 480,width: 24,height: 24},
{name:'symbol_letters_12',x: 72,y: 480,width: 24,height: 24},
{name:'symbol_letters_13',x: 96,y: 480,width: 24,height: 24},
{name:'symbol_letters_14',x: 120,y: 480,width: 24,height: 24},
{name:'symbol_letters_15',x: 144,y: 480,width: 24,height: 24},
{name:'symbol_letters_16',x: 168,y: 480,width: 24,height: 24},
{name:'symbol_letters_17',x: 192,y: 480,width: 24,height: 24},
{name:'symbol_letters_18',x: 216,y: 480,width: 24,height: 24},
{name:'symbol_letters_19',x: 240,y: 480,width: 24,height: 24},
{name:'symbol_letters_20',x: 264,y: 480,width: 24,height: 24},
{name:'symbol_letters_21',x: 288,y: 480,width: 24,height: 24},
{name:'symbol_letters_22',x: 312,y: 480,width: 24,height: 24},
{name:'symbol_letters_23',x: 336,y: 480,width: 24,height: 24},
{name:'symbol_letters_24',x: 360,y: 480,width: 24,height: 24},
{name:'symbol_letters_25',x: 384,y: 480,width: 24,height: 24},
{name:'symbol_letters_26',x: 408,y: 480,width: 24,height: 24},
{name:'symbol_letters_27',x: 432,y: 480,width: 24,height: 24},
{name:'symbol_letters_28',x: 456,y: 480,width: 24,height: 24},
{name:'symbol_letters_29',x: 480,y: 480,width: 24,height: 24},
{name:'symbol_letters_30',x: 504,y: 480,width: 24,height: 24},
{name:'symbol_letters_31',x: 528,y: 480,width: 24,height: 24},
{name:'symbol_letters_32',x: 552,y: 480,width: 24,height: 24},
{name:'symbol_letters_33',x: 576,y: 480,width: 24,height: 24},
]},
{menu: 'function',x: 456,y: 504,width: 54,height: 24,
items: [{name:'sin_x',x: 510,y: 504,width: 44,height: 24},
{name:'sin_inverse_x',x: 554,y: 504,width: 44,height: 24},
{name:'sin_square_x',x: 598,y: 504,width: 44,height: 24},
{name:'sin_super_x',x: 642,y: 504,width: 44,height: 24},
{name:'sin(x)',x: 686,y: 504,width: 44,height: 24},
{name:'sin_inverse(x)',x: 730,y: 504,width: 44,height: 24},
{name:'sin_square(x)',x: 0,y: 528,width: 44,height: 24},
{name:'sin_super(x)',x: 44,y: 528,width: 44,height: 24},
{name:'cos_x',x: 88,y: 528,width: 44,height: 24},
{name:'cos_inverse_x',x: 132,y: 528,width: 44,height: 24},
{name:'cos_square_x',x: 176,y: 528,width: 44,height: 24},
{name:'cos_super_x',x: 220,y: 528,width: 44,height: 24},
{name:'cos(x)',x: 264,y: 528,width: 44,height: 24},
{name:'cos_inverse(x)',x: 308,y: 528,width: 44,height: 24},
{name:'cos_square(x)',x: 352,y: 528,width: 44,height: 24},
{name:'cos_super(x)',x: 396,y: 528,width: 44,height: 24},
{name:'tan_x',x: 440,y: 528,width: 44,height: 24},
{name:'tan_inverse_x',x: 484,y: 528,width: 44,height: 24},
{name:'tan_square_x',x: 528,y: 528,width: 44,height: 24},
{name:'tan_super_x',x: 572,y: 528,width: 44,height: 24},
{name:'tan(x)',x: 616,y: 528,width: 44,height: 24},
{name:'tan_inverse(x)',x: 660,y: 528,width: 44,height: 24},
{name:'tan_square(x)',x: 704,y: 528,width: 44,height: 24},
{name:'tan_super(x)',x: 748,y: 528,width: 44,height: 24},
{name:'cot_x',x: 0,y: 552,width: 44,height: 24},
{name:'cot_inverse_x',x: 44,y: 552,width: 44,height: 24},
{name:'cot_square_x',x: 88,y: 552,width: 44,height: 24},
{name:'cot_super_x',x: 132,y: 552,width: 44,height: 24},
{name:'cot(x)',x: 176,y: 552,width: 44,height: 24},
{name:'cot_inverse(x)',x: 220,y: 552,width: 44,height: 24},
{name:'cot_square(x)',x: 264,y: 552,width: 44,height: 24},
{name:'cot_super(x)',x: 308,y: 552,width: 44,height: 24},
{name:'sec_x',x: 352,y: 552,width: 44,height: 24},
{name:'sec_inverse_x',x: 396,y: 552,width: 44,height: 24},
{name:'sec_square_x',x: 440,y: 552,width: 44,height: 24},
{name:'sec_super_x',x: 484,y: 552,width: 44,height: 24},
{name:'sec(x)',x: 528,y: 552,width: 44,height: 24},
{name:'sec_inverse(x)',x: 572,y: 552,width: 44,height: 24},
{name:'sec_square(x)',x: 616,y: 552,width: 44,height: 24},
{name:'sec_super(x)',x: 660,y: 552,width: 44,height: 24},
{name:'csc_x',x: 704,y: 552,width: 44,height: 24},
{name:'csc_inverse_x',x: 748,y: 552,width: 44,height: 24},
{name:'csc_square_x',x: 0,y: 576,width: 44,height: 24},
{name:'csc_super_x',x: 44,y: 576,width: 44,height: 24},
{name:'csc(x)',x: 88,y: 576,width: 44,height: 24},
{name:'csc_inverse(x)',x: 132,y: 576,width: 44,height: 24},
{name:'csc_square(x)',x: 176,y: 576,width: 44,height: 24},
{name:'csc_super(x)',x: 220,y: 576,width: 44,height: 24},
{name:'limx',x: 264,y: 576,width: 44,height: 24},
{name:'lim(x)',x: 308,y: 576,width: 44,height: 24},
]},
]
;

//JMathEditor editor pane
export default class JME{	
	constructor(url,element,equation,options) {
		this.tab="Editor";
		this.options=options;
		if(equation != undefined)
		{			
			this.equationData = equation;
			this.isNew = false;			
		}
		else
			this.isNew = true;
		this.jmeMenuAction = this.jmeMenuAction.bind(this);
		this.jmeGenerateMenuHtml = this.jmeGenerateMenuHtml.bind(this);
		this.jmeOpenMenu = this.jmeOpenMenu.bind(this);
		
		this.rootElem = document.getElementById(element);
		this.url = this.convertUrl(url,true);		
		this.jmeInit();		
	}
	
	jmeInit()
	{
		this.toolBar = document.createElement("div");	
		this.toolBar.classList.add("jme-toolbar");
		this.jmeGenerateToolbar();
		this.svgDiv = document.createElement("div");
		this.svgDiv.tabIndex="0";
		this.svgDiv.classList.add("jme-content");
		this.svgDiv.style.cursor = 'cursor';
		window.onclick = this.jmeShowHideDropdowns.bind(this);
		this.svgDiv.onkeydown = this.jmeOnContentKeyDown.bind(this); 
		this.svgDiv.onmousedown = this.jmeOnContentClick.bind(this);
		this.svgDiv.onmousemove = this.jmeOnContentMouseMove.bind(this);
		this.svgDiv.onmouseup = this.jmeOnContentMouseUp.bind(this);
		
		this.rootElem.appendChild(this.toolBar);
		this.rootElem.appendChild(this.svgDiv);
		this.jmeGenerateTextOutput();
		this.jmeGenerateImageOutput();		
		this.jmeOpenSocket();
		this.svgDiv.focus();
	}
	convertUrl(url,isws)
	{
		if(url.substring(0,1) === '/')
		{
			var loc = window.location, new_uri;
			if(isws)
			{
				if (loc.protocol === "https:") {
				    new_uri = "wss:";
				} else {
				    new_uri = "ws:";
				}				
			}
			else
				new_uri = loc.protocol;
			new_uri += "//" + loc.host;
			new_uri += url;
			return new_uri;			
		}
		return url;
	}	
	//open web socket and register handlers
	jmeOpenSocket()
	{
		this.jmeWebSocket = new WebSocket(this.url);
		
		this.jmeWebSocket.onopen = this.jmeSocketOpen.bind(this);
		this.jmeWebSocket.onmessage = this.jmeSocketGetMessage.bind(this);
		
		this.jmeWebSocket.onclose = this.jmeSocketClose.bind(this);
		this.jmeWebSocket.onerror = this.jmeSocketError.bind(this);
	}
	jmeFocus()
	{
		this.svgDiv.focus(); 
		var svg = document.getElementById("jmeSvg");
		if(svg!=null)
		{
			var cursor = svg.getElementById("jmeCursor");
		
			if(cursor!=null)
				cursor.style.fill="#0000ff";		
		}
	}
	jmeOnContentKeyDown(event)
	{
		this.jmeWebSocket.send("KEY;"+event.key+";"+event.keyCode+";"+event.altKey+";"+event.ctrlKey+";"+event.shiftKey+";false;");
		event.stopPropagation();
		event.preventDefault();
		this.jmeFocus();
	}
	jmeOnContentClick(event)
	{
		 event = event || window.event;

		  var target = event.currentTarget, //e.target || e.srcElement,
		    rect = target.getBoundingClientRect(),
		    offsetX = Math.round(event.clientX - rect.left),
		    offsetY = Math.round(event.clientY - rect.top);

		 //console.log([offsetX, offsetY]);			 
		 this.jmeWebSocket.send("CLICK;"+offsetX+";"+offsetY+";"+event.altKey+";"+event.ctrlKey+";"+event.shiftKey+";");
		 this.jmeFocus();
	}
	jmeOnContentMouseMove(event)
	{
		 event = event || window.event;
		 if(event.buttons!=1)
			 return;
		  var target = event.currentTarget, //e.target || e.srcElement,
		    rect = target.getBoundingClientRect(),
		    offsetX = Math.round(event.clientX - rect.left),
		    offsetY = Math.round(event.clientY - rect.top);

		 //console.log("mouse move:"+event.buttons+([offsetX, offsetY]));			 
		 event.stopPropagation();
		 event.preventDefault();
		 this.jmeWebSocket.send("MOUSE;"+offsetX+";"+offsetY+";");
	}
	jmeOnContentMouseUp(event)
	{
		 event = event || window.event;

		 var target = event.currentTarget, //e.target || e.srcElement,
		    rect = target.getBoundingClientRect(),
		    offsetX = Math.round(event.clientX - rect.left),
		    offsetY = Math.round(event.clientY - rect.top);

		 //console.log("mouse move:"+event.buttons+([offsetX, offsetY]));			 
		 event.stopPropagation();
		 event.preventDefault();
		 if(!this.jmeWebSocket === undefined)
			 this.jmeWebSocket.send("MOUSEUP;"+offsetX+";"+offsetY+";");
	}
	//hide all dropdowns
	jmeShowHideDropdowns(event)
	{
	    var dropdowns = document.getElementsByClassName("jme-dropdown-content");
	    var i;
	    for (i = 0; i < dropdowns.length; i++) {
	      var openDropdown = dropdowns[i];
	      if(event == undefined || event.target.id!=openDropdown.id+'-btn')
	      {
	      if (openDropdown.classList.contains('jme-show-menu'))
	        openDropdown.classList.remove('jme-show-menu');
	      }
	    }
	}
	
	jmeSocketGetMessage(message) {
		var jsonObj = JSON.parse(message.data);
		if(jsonObj.echo != undefined)
		{
			var d = new Date();
			this.echoTime = d.getTime() - this.echoTime;
			console.log("echo duration: "+this.echoTime);
			this.echoCallback(this.echoTime);
			return;
		}
		if(document.getElementById(this.rootElem.id)!=null)
		{
			document.getElementById(this.rootElem.id+"-color-btn").style.color = jsonObj.color;	
			document.getElementById(this.rootElem.id+"-zoom-btn").innerHTML = '%'+jsonObj.zoom;
			document.getElementById(this.rootElem.id+"-style-btn").innerHTML = jsonObj.style;
		}
		this.svgDiv.innerHTML = jsonObj.svg;
		if(jsonObj.data!=null)
		{
			if(jsonObj.dataType == 'PNG' && this.pngCallback != undefined )
			{
				this.pngCallback(jsonObj.data,jsonObj.width,jsonObj.height);
				this.pngCallback = undefined;
			}
			else if(jsonObj.dataType == 'MATHML' && this.mathmlCallback != undefined)
			{
				this.mathmlCallback(jsonObj.data,jsonObj.align);
				this.mathmlCallback = undefined;
			}
			else if(jsonObj.dataType == 'SVG' && this.svgCallback != undefined)
			{
				this.svgCallback(jsonObj.data);
				this.svgCallback = undefined;
			}
			else if(jsonObj.dataType == 'TEX' && this.texCallback != undefined)
			{
				this.texCallback(jsonObj.data);
				this.texCallback = undefined;
			}
			else if(jsonObj.dataType == 'EMF' && this.emfCallback != undefined)
			{
				this.emfCallback(jsonObj.data,jsonObj.align);
				this.emfCallback = undefined;
			}
		}
	}
	jmeEcho(callback)
	{
		var d = new Date();
		this.echoTime = d.getTime();
		console.log("echo start: "+this.echoTime);
		this.echoCallback = callback;
		this.jmeWebSocket.send("ECHO;Hello_JMathEdit_v3;");
	}
	jmeSocketOpen(message) {
		console.log("Connected ... \n");
		if(this.options!=undefined)
			this.jmeWebSocket.send("INIT;"+this.options.theme+";"+this.options.size);
		if(this.equationData != undefined)
			this.jmeLoadEquation(this.equationData);
	}

	jmeMenuAction(command)
	{
		this.jmeWebSocket.send("MENU;"+command+";");
		this.jmeFocus();
		this.jmeShowHideDropdowns();	
	}
	jmeFocusOut(){
		var svg = document.getElementById("jmeSvg");
		if(svg!=null)
		{
			var cursor = svg.getElementById("jmeCursor");
			if(cursor!=null)
				cursor.style.fill="none";	
		}
	};

	jmeCloseConnection() {
		this.jmeWebSocket.close();
	}
	jmeGet(fmt,callback)
	{
		if(fmt=="SVG")
			this.jmeGetSVG(callback);
		else if(fmt=="MathML")
			this.jmeGetMathML(callback);
		else if(fmt=="TeX")
			this.jmeGetTeX(callback);
		else if(fmt=="PNG")
			this.jmeGetPNG(callback);
		else if(fmt=="EMF")
			this.jmeGetEMF(callback);
	}
	jmeGetPNG(callback)
	{
		this.pngCallback = callback;
		this.jmeWebSocket.send("GETDOC;PNG;");
		this.jmeFocus();
		this.jmeShowHideDropdowns();
	}
	jmeLoadEquation(data)
	{
		var b64=btoa(data);
		this.jmeWebSocket.send("LOADDOC;"+b64+";");
		this.jmeFocus();
		this.jmeShowHideDropdowns();
	}
	jmeGetSVG(callback)
	{
		this.svgCallback = callback;
		this.jmeWebSocket.send("GETDOC;SVG;");
		this.jmeFocus();
		this.jmeShowHideDropdowns();
	}
	jmeGetEMF(callback)
	{
		this.emfCallback = callback;
		this.jmeWebSocket.send("GETDOC;EMF;");
		this.jmeFocus();
		this.jmeShowHideDropdowns();
	}	
	jmeGetTeX(callback)
	{
		this.texCallback = callback;
		this.jmeWebSocket.send("GETDOC;TEX;");
		this.jmeFocus();
		this.jmeShowHideDropdowns();
	}	
	jmeGetMathML(callback)
	{
		this.mathmlCallback = callback;		
		this.jmeWebSocket.send("GETDOC;MATHML;");
		this.jmeFocus();
		this.jmeShowHideDropdowns();	
	}

	jmeSocketClose(message) {
		console.log("Disconnect ... \n");
	}

	jmeSocketError(message) {
		console.log("Error ... \n");
	}
	jmeGenerateMenuHtml(menu,prnt)
	{
		var that = this;
		let cls="icon";
		if(menu.menu=='function')
			cls="iconf";
		menu.items.forEach(function(entry) {
			var mi = document.createElement("a");
			mi.href="#";
			mi.style.backgroundPosition = '-'+entry.x+'px -'+entry.y+'px';
			mi.classList.add(cls);
			mi.onclick = function(event){
				event.preventDefault();					
				that.jmeMenuAction(entry.name)
			};
			prnt.appendChild(mi);
		});
	}
	jmeGenerateTextOutput()
	{
		var dd = document.createElement("div");
		dd.classList.add("jme-output");
		dd.id="jme-output";
		var ta = document.createElement("textarea");
		ta.classList.add("jme-output-text");
		ta.id="jme-output-text";
		ta.setAttribute("spellcheck","false");
		dd.appendChild(ta);
		this.rootElem.appendChild(dd);
		this.outputDiv = dd;
		this.outputText = ta;
	}
	jmeGenerateImageOutput()
	{
		var dd = document.createElement("div");
		dd.classList.add("jme-output");
		dd.id="jme-output-image";
		var ta = document.createElement("img");
		ta.classList.add("jme-output-image");
		ta.id="jme-output-image";
		dd.appendChild(ta);
		this.rootElem.appendChild(dd);
		this.outputImageDiv = dd;
		this.outputImage = ta;
	}	
	showTab(tab,fmt)
	{
		this.svgDiv.style.display="none";
		this.outputDiv.style.display="none";
		this.outputImageDiv.style.display="none";
		
		if(tab=="output")
			this.outputDiv.style.display="block";
		else if(tab=="editor")
			this.svgDiv.style.display="block";
		else if(tab=="image")
			this.outputImageDiv.style.display="block";
		this.tab = tab;
		var tabBtn = document.getElementById(this.rootElem.id+"-content-btn");
		tabBtn.innerHTML='<span>'+fmt+'</span>'		
		if(tab=="output")
		{
			this.outputText.select();
			this.outputText.setSelectionRange(0, 99999); /*For mobile devices*/
			document.execCommand("copy");			
		}
		if(tab=="editor")
			this.jmeFocus();
	}
	jmeGenerateToolbar()
	{
		var that=this;
		jmeMenus.forEach(function(entry){
			let dd = document.createElement("div");
			dd.classList.add('jme-dropdown');
			let btn = document.createElement("button");
			btn.classList.add('jme-dropdown-btn');
			btn.style.backgroundPosition = "-"+entry.x+"px -"+entry.y+"px";
			btn.id = that.rootElem.id+'-'+entry.menu+'-btn';
			btn.onclick = function(event){
				event.preventDefault();					
				that.jmeOpenMenu(that.rootElem.id+'-'+entry.menu,event);
			};
			let con = document.createElement("div");
			con.classList.add('jme-dropdown-content');
			con.id = that.rootElem.id+'-'+entry.menu;
			that.jmeGenerateMenuHtml(entry,con);
			dd.appendChild(btn);
			dd.appendChild(con);			
			that.toolBar.appendChild(dd);
		});
		this.jmeGenerateZoomMenu();
		this.jmeGenerateStyleMenu();
		this.jmeGenerateSizeMenu();
		this.jmeGenerateThemeMenu();
		this.jmeGenerateColorMenu();
		this.jmeGenerateContentMenu();
	}
	jmeAddButton(prnt,onclick,txt)
	{
		var mi = document.createElement("a");
		mi.classList.add("jme-list-item");
		mi.href="#";
		mi.onclick = onclick;
		mi.text = txt;
		prnt.appendChild(mi);
	}
	jmeGenerateZoomMenu()
	{
		var that=this;
		let dd = document.createElement("div");
		dd.classList.add('jme-dropdown');
		let btn = document.createElement("button");
		btn.classList.add('jme-dropdown-btn');
		btn.classList.add('jme-no-icon');
		btn.id = that.rootElem.id+"-zoom-btn";
		btn.onclick = function(event){that.jmeOpenMenu(that.rootElem.id+'-zoom',event)};
		let con = document.createElement("div");
		con.classList.add('jme-dropdown-content');
		con.id = that.rootElem.id+'-zoom';
		
		var zoomVals = [100,120,150,200,300,400,500];
		for(var i=0;i<zoomVals.length;i++)
		{
			let zoom=zoomVals[i];
			this.jmeAddButton(con,function(event){
				event.preventDefault();
				that.jmeMenuAction('zoom'+zoom)
				},'%'+zoom);			
		}
		
		dd.appendChild(btn);
		dd.appendChild(con);			
		that.toolBar.appendChild(dd);
	}
	jmeGenerateStyleMenu()
	{
		var that=this;
		let dd = document.createElement("div");
		dd.classList.add('jme-dropdown');
		let btn = document.createElement("button");
		btn.classList.add('jme-dropdown-btn');
		btn.classList.add('jme-no-icon');
		btn.id = that.rootElem.id+"-style-btn";
		btn.onclick = function(event){that.jmeOpenMenu(that.rootElem.id+'-style',event)};
		let con = document.createElement("div");
		con.classList.add('jme-dropdown-content');
		con.id = that.rootElem.id+'-style';

		var styleVals = ['default','text','identifier','function'];
		var styleNames = ['Auto','Text','Identifier','Function'];
		
		for(var i=0;i<styleVals.length;i++)
		{
			let style=styleVals[i];
			this.jmeAddButton(con,function(event){
				event.preventDefault();
				that.jmeMenuAction('style_'+style)
				},styleNames[i]);			
		}
		
		dd.appendChild(btn);
		dd.appendChild(con);			
		that.toolBar.appendChild(dd);
	}	
	jmeGenerateSizeMenu()
	{
		var that=this;
		let dd = document.createElement("div");
		dd.classList.add('jme-dropdown');
		let btn = document.createElement("button");
		btn.classList.add('jme-dropdown-btn');
		btn.classList.add('jme-no-icon');
		btn.id = that.rootElem.id+"-size-btn";
		btn.onclick = function(event){that.jmeOpenMenu(that.rootElem.id+'-size',event)};
		btn.innerHTML='<span style="font-size: 16px;">A</span> <span style="font-size: 10px;">A</span>'
		let con = document.createElement("div");
		con.classList.add('jme-dropdown-content');
		con.id = that.rootElem.id+'-size';
		var sz=[8,9,10,11,12,13,14,15,16,18,20,24,30,40,72];
		for(var i=0;i<15;i++)
		{
			let siz = sz[i];
			this.jmeAddButton(con,function(event){
				event.preventDefault();
				that.jmeMenuAction('size_'+siz)
				},siz+'pt');			
		}
		
		dd.appendChild(btn);
		dd.appendChild(con);			
		that.toolBar.appendChild(dd);
	}	
	jmeGenerateContentMenu()
	{
		var that=this;
		let dd = document.createElement("div");
		dd.classList.add('jme-dropdown');
		let btn = document.createElement("button");
		btn.classList.add('jme-dropdown-btn');
		btn.classList.add('jme-no-icon');
		btn.id = that.rootElem.id+"-content-btn";
		btn.onclick = function(event){
			that.jmeOpenMenu(that.rootElem.id+'-content',event)
		};
		btn.innerHTML='<span>'+this.tab+'</span>'
		let con = document.createElement("div");
		con.classList.add('jme-dropdown-content');
		con.id = that.rootElem.id+'-content';
		var sz=["SVG","MathML","TeX"];
		
		this.jmeAddButton(con,function(event){
			event.preventDefault();
			that.showTab("editor","Editor");
		},'Editor');
		
		for(var i=0;i<3;i++)
		{
			let siz = sz[i];
			this.jmeAddButton(con,function(event){
				event.preventDefault();
				that.jmeGet(siz,function(data){
					that.outputText.value=data;
					that.showTab("output",siz);
				});
			},siz);
		}
		this.jmeAddButton(con,function(event){
			event.preventDefault();
			that.jmeGet("PNG",function(data,w,h){
				that.outputImage.setAttribute('src', 'data:image/png;base64, '+data); 
				//that.outputImage.setAttribute('width',w);
				//that.outputImage.setAttribute('height',h);
				that.outputImage.style.width=(w/20.0)+"pt";
				that.outputImage.style.height=(h/20.0)+"pt";
				that.showTab("image","PNG");
			});
		},"PNG");
		
		dd.appendChild(btn);
		dd.appendChild(con);			
		that.toolBar.appendChild(dd);
	}		
	jmeGenerateThemeMenu()
	{
		var that=this;
		let dd = document.createElement("div");
		dd.classList.add('jme-dropdown');
		let btn = document.createElement("button");
		btn.classList.add('jme-dropdown-btn');
		btn.classList.add('jme-no-icon');
		btn.id = that.rootElem.id+"-theme-btn";
		btn.innerHTML = '<span style="font-family: serif;">T</span>';
		btn.onclick = function(event){that.jmeOpenMenu(that.rootElem.id+'-theme',event)};
		let con = document.createElement("div");
		con.classList.add('jme-dropdown-content');
		con.id = that.rootElem.id+'-theme';
		
		var styleVals = ['latin_modern_serif_italic','latin_modern_sans_serif','pagella','pagella_sans','termes','termes_sans','dejavu_sans','dejavu_serif'];
		var styleNames = ['Latin Modern Serif','Latin Modern Sans Serif','TG Pagella','TG Pagella Sans Serif','TG Termes','TG Termes Sans Serif','DejaVu Sans','DejaVu Serif'];
		
		for(var i=0;i<styleVals.length;i++)
		{
			let style=styleVals[i];
			this.jmeAddButton(con,function(event){
				event.preventDefault();
				that.jmeMenuAction('theme_'+style)
				},styleNames[i]);			
		}
		
		dd.appendChild(btn);
		dd.appendChild(con);			
		that.toolBar.appendChild(dd);
	}		
	jmeGenerateColorMenu()
	{
		var that=this;
		let dd = document.createElement("div");
		dd.classList.add('jme-dropdown');
		let btn = document.createElement("button");
		btn.classList.add('jme-dropdown-btn');
		btn.classList.add('jme-no-icon');
		btn.style.color="#000";
		btn.style.fontSize="20px";
		btn.innerHTML="&#9724;";
		btn.id = that.rootElem.id+"-color-btn";
		btn.onclick = function(event){that.jmeOpenMenu(that.rootElem.id+'-color',event)};
		let con = document.createElement("div");
		con.classList.add('jme-dropdown-content');
		con.id = that.rootElem.id+'-color';

		var cv = [ '00', '56', 'aa', 'ff' ];
		for (var r = 0; r < 4; r++)
			for (var g = 0; g < 4; g++)
				for (var b = 0; b < 4; b++)
				{
					let cl=cv[r]+cv[g]+cv[b];
					var mi = document.createElement("a");
					mi.classList.add("jme-color-icon");
					mi.onclick = function(event){
						event.preventDefault();
						that.jmeMenuAction('color'+cl)
					};
					mi.innerHTML = '<div style="width:16px;height:16px;background:#'+cl+'"></div>';
					con.appendChild(mi);
				}
		dd.appendChild(btn);
		dd.appendChild(con);			
		that.toolBar.appendChild(dd);		
	}			
	jmeOpenMenu(menuName,event)
	{
		this.jmeShowHideDropdowns(event);
		var mn = document.getElementById(menuName);
		mn.classList.toggle("jme-show-menu");
		
		var parentRect = this.toolBar.getBoundingClientRect();
		var rect = mn.getBoundingClientRect();
		if(rect.x + rect.width>parentRect.x+parentRect.width)
		{
			mn.style.left = ""+-(rect.x + rect.width -parentRect.x - parentRect.width )+"px";
		}
		event.stopPropagation();
	}
}

